import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    position: 'relative',
  },
  text: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  circle1: {
    fill: 'none',
  },
  circle2: {
    fill: 'none',
    animation: '$progress 1s ease-out forwards',
  },
  '@keyframes progress': {
    '0%': {
      strokeDasharray: '0 100',
    },
  },
});

export default useStyles;
